// Extra 7 — Ticket Bonus winnings grid (à propos page).
// The Ticket Bonus is a single-tier add-on: each result count pays one fixed
// cash amount (no Boost tiers, no FreeBet). Amounts are pre-formatted display
// strings (space thousands separator, GNF appended in the template) to match
// the printed marketing grid exactly.

export interface Extra7BonusRow {
    // count of correct numbers (out of 4) — fed to the translated row label
    count: number;
    // cash win for this result count
    cash: string;
    // Extra 7 - 4 Numéros standard win for the same result count
    standard: string;
    // standard + bonus, what the pack pays in total
    total: string;
}

export const extra7BonusGains: Extra7BonusRow[] = [
    { count: 2, standard: "30 000", cash: "20 000", total: "50 000" },
    { count: 3, standard: "370 000", cash: "80 000", total: "450 000" },
    { count: 4, standard: "17 000 000", cash: "3 000 000", total: "20 000 000" },
];
